module.exports = require('./helpers/bundle-url').getBundleURL('9U9Lq') + "image-2.54746521.png";